import React from 'react';

export default function About() {

  return (
    <div style={{ padding: 20 }}>
   <h2>About Page</h2>
    <p>This is Dove.  Version 2024-11-27..</p>
  </div>
  ) ;
}
